import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import './CustomBox.scss';

const CustomBox = props => {
  return (
    <Box
      {...omit(props, 'children', 'style')}
      className={`CustomBox ${props.className || ''}`}
      style={{
        border: props.borderless ? '0' : '',
        ...(props.style || {})
      }}
    >
      {props.children}
    </Box>
  );
};

CustomBox.propTypes = {
  style: PropTypes.object,
  borderless: PropTypes.bool,
};

export default CustomBox;
